<template>
    <div class="technicalParameter_container">
        <el-drawer
            :title="lang.technicalParameter"
            :visible.sync="show"
            direction="rtl"
            class="technicalParameter_drawer"
            :size="drawerSize"
        >
            <div class="technicalParameter_content">
                <div class="technicalParameter_item">
                    <h3 class="product_title">{{ id }}</h3>
                    <template v-if="id!=='GEMINI40T'">
                        <div v-for="(product, productIndex) in currentProduct" :key="productIndex" class="parameter-section">
                            <div class="technicalParameter_title">{{ product[`name_${currentLanguage}`] }}</div>
                            <template v-if="product[`tableData_${currentLanguage}`]">
                                <el-table
                                    :data="product[`tableData_${currentLanguage}`]"
                                    border
                                    style="width: 100%"
                                    :span-method="spanMethod(product[`tableData_${currentLanguage}`])"
                                    class="parameter-table"
                                >
                                    <template v-for="item in product[`headers_${currentLanguage}`]">
                                        <el-table-column
                                            :prop="item.prop"
                                            :label="item.label"
                                            :key="item.prop"
                                        ></el-table-column>
                                    </template>
                                </el-table>
                            </template>
                        </div>
                    </template>
                    <template v-else>
                        <div class="image-container" v-for="(product, productIndex) in currentProduct" :key="productIndex">
                            <div class="image-item" v-for="(image, imageIndex) in product[`imageList_${currentLanguage}`]" :key="imageIndex">
                                <img :src="image" alt="">
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import { cloneDeep } from "lodash";
export default {
    model: {
        prop: "value",
        event: "change",
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: "",
        },
    },
    mixins: [],
    name: "technicalParameter",
    components: {},
    computed: {
        currentLanguage() {
            return this.$store.state.language.currentLanguage;
        },
        lang() {
            return this.$store.state.language;
        },
        drawerSize() {
            return window.innerWidth <= 768 ? '100%' : '650px';
        }
    },
    watch: {
        value: {
            handler(val) {
                this.show = val;
                if (val) {
                    this.currentProduct = this.allProductsMap[this.id];
                    this.currentProduct.forEach((item) => {
                        this.formateTableDataSpan(item[`tableData_${this.currentLanguage}`]);
                    });
                }
            },
        },
        show: {
            handler(val) {
                this.$emit("change", val);
            },
        },
    },
    data() {
        return {
            show: false,
            currentProduct: [],
            allProductsMap: {},
        };
    },
    created() {
        this.allProductsMap = {
            SCORPIO4: [
                {
                    name_CN: "机械@电子特性",
                    name_EN: "Mechanical @ Electronic Characteristics",
                    headers_CN: [
                        { label: "参数", prop: "key" },
                        { label: "说明", prop: "value" },
                    ],
                    headers_EN: [
                        { label: "Parameters", prop: "key" },
                        { label: "Description", prop: "value" },
                    ],
                    tableData_CN: [
                        { key: "工作电压", value: "18V" },
                        { key: "静态电流", value: "1.5A@12V" },
                        { key: "算力", value: "21TOPS" },
                        { key: "工作温度", value: "-20°C～+55°C" },
                        { key: "防水等级", value: "IP55" },
                        { key: "重量", value: "840g" },
                    ],
                    tableData_EN: [
                        { key: "Voltage", value: "18V" },
                        { key: "Static Current", value: "1.5A@12V" },
                        { key: "Computing Power", value: "21TOPS" },
                        { key: "Operating Temperature", value: "-20°C～+55°C" },
                        { key: "Waterproof Rating", value: "IP55" },
                        { key: "Weight", value: "840g" },
                    ],
                },
                {
                    name_CN: "工作特性",
                    name_EN: "Working characteristics",
                    headers_CN: [
                        { label: "参数", prop: "key" },
                        { label: "说明", prop: "value" },
                    ],
                    headers_EN: [
                        { label: "Parameters", prop: "key" },
                        { label: "Description", prop: "value" },
                    ],
                    tableData_CN: [
                        { key: "横滚角动作范围", value: "-85°~+85°" },
                        { key: "俯仰角度动作范围", value: "-135°~+45°" },
                        { key: "航向角动作范围", value: "±150°" },
                        { key: "角度抖动量", value: "± 0.01°" },
                    ],
                    tableData_EN: [
                        { key: "Roll Angle Range", value: "-85°~+85°" },
                        { key: "Pitch Angle Range", value: "-135°~+45°" },
                        { key: "Yaw Angle Range", value: "±150°" },
                        { key: "Angle Jitter", value: "± 0.01°" },
                    ],
                },
                {
                    name_CN: "可见光SONY变焦相机",
                    name_EN: "18x Telephoto Lens with SONY sensor",
                    headers_CN: [
                        { label: "类别", prop: "category" },
                        { label: "参数", prop: "key" },
                        { label: "说明", prop: "value" },
                    ],
                    headers_EN: [
                        { label: "Specifications", prop: "category" },
                        { label: "Parameters", prop: "key" },
                        { label: "Description", prop: "value" },
                    ],
                    tableData_CN: [
                        { category: "Sensor", key: "大小", value: '1/2" CMOS' },
                        { category: "Sensor", key: "总像素", value: "4800万" },
                        { category: "Sensor", key: "最大分辨率", value: "4000 (H) × 3000 (V)" },
                        { category: "镜头", key: "光学变焦", value: "f: 6.8~120mm 等效焦距 36.72~648mm" },
                        { category: "镜头", key: "FNo", value: "FNo: 1.6~4.13" },
                        { category: "镜头", key: "最小拍摄距离", value: "2m" },
                        { category: "镜头", key: "视场角（对角）", value: "66.1° ~4.3°" },
                        { category: "视频", key: "视频/图片模式", value: "支持 H.265/H.264/JPEG/JPG/MP4" },
                        { category: "视频", key: "存储功能", value: "支持TF卡存储，最大支持256G容量" },
                        { category: "视频", key: "网络协议", value: "HTTP, RTSP, TCP, UDP" },
                        { category: "智能功能", key: "智能功能", value: "智能识别及自动跟踪" },
                        {
                            category: "视频分辨率",
                            key: "视频分辨率",
                            value: "25fps (4000 × 3000) (1200万/2000万/2400万/4800万)",
                        },
                        { category: "信噪比 (S/N)", key: "信噪比 (S/N)", value: ">55dB (AGC Off, Weight ON)" },
                        { category: "最低照度", key: "最低照度", value: "彩色: 0.1Lux/F1.5; 黑白: 0.01Lux/F1.5" },
                        { category: "防抖", key: "防抖", value: "支持电子防抖开/关" },
                        { category: "透雾", key: "透雾", value: "开/关" },
                        { category: "聚光补偿", key: "聚光补偿", value: "开/关" },
                        { category: "强光抑制", key: "强光抑制", value: "支持" },
                        { category: "日夜模式", key: "日夜模式", value: "自动/手动" },
                        { category: "变倍速度", key: "变倍速度", value: "18倍全程 4.5S（光学，广角-望远）" },
                        { category: "白平衡", key: "白平衡", value: "自动/跟踪/室外/室内/室内自动/钠灯自动/钠灯" },
                        { category: "电子快门", key: "电子快门", value: "支持自动和手动电子快门 1/3~1/30000 秒" },
                        { category: "曝光", key: "曝光", value: "支持自动和手动两种模式" },
                        { category: "2D降噪功能", key: "2D降噪功能", value: "支持" },
                        { category: "3D降噪功能", key: "3D降噪功能", value: "支持" },
                        { category: "图像翻转", key: "图像翻转", value: "支持" },
                        { category: "通信控制", key: "通信控制", value: "RS232" },
                        { category: "聚焦模式", key: "聚焦模式", value: "自动/手动/一次性自动聚焦" },
                        { category: "工作温度", key: "工作温度", value: "-20°C~+70°C / 20%~80% RH" },
                        { category: "储藏环境", key: "储藏环境", value: "-40°C~+70°C / 20%~95% RH" },
                    ],
                    tableData_EN: [
                        { category: "Sensor", key: "Size", value: '1/2"CMOS' },
                        { category: "Sensor", key: "Pixels", value: "48M" },
                        { category: "Sensor", key: "Resolutions", value: "4000(H) x 3000(V)" },
                        {
                            category: "Lens",
                            key: "Focal length",
                            value: "f: 6.8~120mm equivalent focal length 36.72~648mm",
                        },
                        { category: "Lens", key: "Aperture", value: "FNo: 1.61~4.13" },
                        { category: "Lens", key: "Minimum Focus", value: "2m" },
                        { category: "Lens", key: "FOV (diagonal)", value: "66.1°~4.3°" },
                        {
                            category: "Video/Photo Format",
                            key: "Video/photo format",
                            value: "H.265/H.264/JPEG/JPG/MP4",
                        },
                        {
                            category: "Video/Photo Format",
                            key: "Storage",
                            value: "Supported a microSD card with capacity up to 256G",
                        },
                        { category: "Video/Photo Format", key: "Protocol", value: "HTTP,RTSP,TCP,UDP" },
                        { category: "AI", key: "AI Mode", value: "AI identify & tracking" },
                        { category: "Video resolution", key: "Video resolution", value: "25fps (4000 x 3000) (12M)" },
                        { category: "Photo resolution", key: "Photo resolution", value: "12M/20M/24M/48M" },
                        { category: "AI MODE", key: "AI MODE", value: "Target Tracking" },
                        { category: "S/N ratio", key: "S/N ratio", value: "≥55dB (AGC Off, Weight ON)" },
                        {
                            category: "Illumination",
                            key: "Illumination",
                            value: "Multicolor: 0.1Lux/F1.5, monochrome: 0.01Lux/F1.5",
                        },
                        {
                            category: "Vibration deduction",
                            key: "Vibration deduction",
                            value: "Supports a digital vibration deduction mode",
                        },
                        { category: "Exposure compensation", key: "Exposure compensation", value: "±3.0" },
                        { category: "Back Light Compensation", key: "Back Light Compensation", value: "YES" },
                        { category: "Day-Light Switch", key: "Day-Light Switch", value: "Auto/Manual" },
                        { category: "Zoom time", key: "Zoom time", value: "1x-18x 4.5S" },
                        {
                            category: "Multi-digital zoom",
                            key: "Multi-digital zoom",
                            value: "MAX Up to 200x digital zoom",
                        },
                        {
                            category: "White balance",
                            key: "White balance",
                            value: "Auto, ATW, Indoor, Outdoor, Outdoor Auto, Sodium Vapor Lamp (Fix/Auto/Outdoor Auto)",
                        },
                        {
                            category: "Electronic shutter",
                            key: "Electronic shutter",
                            value: "1/3～1/30000s (AUTO/ MANUAL)",
                        },
                        { category: "Exposure control", key: "Exposure control", value: "AUTO/ MANUAL" },
                        { category: "Defog", key: "Defog", value: "YES" },
                        { category: "2D/3D Noise reduction", key: "2D/3D Noise reduction", value: "YES" },
                        { category: "Image flip", key: "Image flip", value: "YES" },
                        { category: "AF MODE", key: "AF MODE", value: "Manual/Auto/ One-time AF" },
                        {
                            category: "Working environment",
                            key: "Working environment",
                            value: "-20℃～+70℃/20%～ 80% RH",
                        },
                        {
                            category: "Storage environment",
                            key: "Storage environment",
                            value: "-40℃～+70℃/20%～ 95% RH",
                        },
                    ],
                },
                {
                    name_CN: "可见光SONY广角相机",
                    name_EN: "Wide Lens with SONY Senor",
                    headers_CN: [
                        { label: "类别", prop: "category" },
                        { label: "参数", prop: "key" },
                        { label: "说明", prop: "value" },
                    ],
                    headers_EN: [
                        { label: "Specifications", prop: "category" },
                        { label: "Parameters", prop: "key" },
                        { label: "Description", prop: "value" },
                    ],
                    tableData_CN: [
                        { category: "Sensor", key: "大小", value: '1/2" CMOS' },
                        { category: "Sensor", key: "总像素", value: "4800万" },
                        { category: "Sensor", key: "最大分辨率", value: "4000 (H) x 3000 (V)" },
                        { category: "Sensor", key: "光学变焦", value: "广角镜头" },
                        { category: "镜头", key: "光圈", value: "F/1.8" },
                        { category: "镜头", key: "焦距", value: "4.7mm" },
                        { category: "镜头", key: "最小拍摄距离", value: "0.1m" },
                        { category: "镜头", key: "视场角 (对角)", value: "DFOV 79.1°" },
                        { category: "视频网络", key: "视频压缩模式", value: "支持 H.265/H.264/JPEG/JPG/MP4" },
                        { category: "视频网络", key: "存储功能", value: "支持 TF 卡存储，最大支持 256G 容量" },
                        { category: "视频网络", key: "网络协议", value: "Onvif, GB28181, HTTP, RTSP, RTP, TCP, UDP" },
                        { category: "视频网络", key: "智能功能", value: "自动跟踪" },
                        { category: "分辨率", key: "图片", value: "1200万/2000万/2400万/4800万" },
                        { category: "分辨率", key: "视频", value: "25fps (4000 x 3000) (1200万)" },
                    ],
                    tableData_EN: [
                        { category: "Sensor", key: "Size", value: '1/2" CMOS' },
                        { category: "Sensor", key: "Effective Pixels", value: "48M" },
                        { category: "Sensor", key: "Resolutions", value: "4000 (H) x 3000 (V)" },
                        { category: "Sensor", key: "Focal length", value: "F/1.8" },
                        { category: "Sensor", key: "Aperture", value: "4.7mm" },
                        { category: "Sensor", key: "Minimum Focus", value: "0.1m" },
                        { category: "Sensor", key: "FO（diagonal）", value: "DFOV 79.1°" },
                        { category: "Video Format", key: "Video/photo format", value: "H.265/H.264/JPEG/JPG/MP4" },
                        {
                            category: "Video Format",
                            key: "Storage",
                            value: "Supported a microSD card with capacity up to 256G",
                        },
                        {
                            category: "Video Format",
                            key: "Protocol",
                            value: "Onvif, GB28181, HTTP, RTSP, RTP, TCP, UDP",
                        },
                        { category: "Video Format", key: "AI Mode", value: "Target identify/tracking" },
                        { category: "Resolution", key: "Photo", value: "12M/20M/24M/48M" },
                        { category: "Resolution", key: "Video", value: "25fps（4000×3000）（12M）" },
                    ],
                },
                {
                    name_CN: "13mm热成像仪",
                    name_EN: "13mm Lens-Infrared thermal camera",
                    headers_CN: [
                        { label: "参数", prop: "key" },
                        { label: "说明", prop: "value" },
                    ],
                    headers_EN: [
                        { label: "Parameters", prop: "key" },
                        { label: "Description", prop: "value" },
                    ],
                    tableData_CN: [
                        { key: "光谱", value: "8um-14um" },
                        { key: "分辨率", value: "640x512" },
                        { key: "像元尺寸", value: "12*12um" },
                        { key: "焦距", value: "13.1mm（等效焦距 56mm）" },
                        { key: "NETD（噪声等效温差）", value: "≤50mK@f1.0（@25°C）" },
                        { key: "图像显示", value: "黑热/白热/伪彩色" },
                        { key: "电子变倍", value: "1X，2X，4X，8X" },
                        { key: "工作温度", value: "-40°C~+70°C" },
                        { key: "测量工作环境范围", value: "-10°C~+50°C" },
                        { key: "测温目标范围", value: "-20°C~+150°C，100~550°C" },
                        { key: "区域测温", value: "支持点测温和区域测温，输出区域最大值最小值平均值" },
                        { key: "帧率", value: "25fps" },
                    ],
                    tableData_EN: [
                        { key: "Spectrum", value: "8um-14um" },
                        { key: "Resolution", value: "640x512" },
                        { key: "Sensor Size", value: "12*12um" },
                        { key: "Focal Length", value: "13.1mm（Equivalent focal Length 56mm）" },
                        { key: "NETD", value: "≤50mK@f1.0（@25°C）" },
                        {
                            key: "Palette",
                            value: "White Hot/Fulgurite/Iron Red/Hot Iron/Medical/Arctic/Rainbow1/ Rainbow 2/Tint/Black Hot",
                        },
                        { key: "Digital zoom", value: "1X，2X，4X，8X" },
                        { key: "Working temperature", value: "-40°C~+70°C" },
                        { key: "Temperature measurement Working temperature", value: "-10°C~+50°C" },
                        { key: "Sense Range", value: "-20°C~+150°C，100~550°C" },
                        { key: "Measure Methods", value: "Spot meter/ Area Measuremen" },
                        { key: "Frame rate", value: "25fps" },
                    ],
                },
                {
                    name_CN: "2000m激光测距参数表",
                    name_EN: "2000m Laser-rangefinder",
                    headers_CN: [
                        { label: "参数", prop: "key" },
                        { label: "说明", prop: "value" },
                    ],
                    headers_EN: [
                        { label: "Parameters", prop: "key" },
                        { label: "Description", prop: "value" },
                    ],
                    tableData_CN: [
                        { key: "距离", value: "3-2000m" },
                        { key: "距离测量分辨率", value: "0.1m" },
                        { key: "距离测量精度", value: "1m" },
                        { key: "发射光束", value: "905nm 脉冲" },
                        { key: "激光光束发散角", value: "3.2mrad" },
                        { key: "工作范围", value: "-10℃~+50℃ 精度+/-1m" },
                    ],
                    tableData_EN: [
                        { key: "Range", value: "3-2000m" },
                        { key: "Resolution", value: "0.1m" },
                        { key: "Measure Accuracy", value: "1m" },
                        { key: "Wavelength", value: "905nm" },
                        { key: "Beam divergence angle", value: "3.2mrad" },
                        { key: "Accuracy", value: "accuracy +/-1m" },
                    ],
                },
            ],
            LIBRA4: [
                {
                    name_CN: "广角相机",
                    name_EN: "Wide Lens",
                    headers_CN: [
                        { label: "类别", prop: "category" },
                        { label: "参数", prop: "key" },
                        { label: "说明", prop: "value" },
                    ],
                    headers_EN: [
                        { label: "Specifications", prop: "category" },
                        { label: "Parameters", prop: "key" },
                        { label: "Description", prop: "value" },
                    ],
                    tableData_CN: [
                        { category: "影像传感器", key: "影像传感器", value: '1/2" CMOS，有效像素4800万' },
                        { category: "镜头", key: "视场角", value: "79°" },
                        { category: "镜头", key: "等效焦距", value: "等效焦距 25mm" },
                        { category: "镜头", key: "光圈", value: "F/1.8" },
                        { category: "镜头", key: "对焦点", value: "5米至无穷远" },
                        { category: "ISO范围", key: "ISO范围", value: "100 至 25600" },
                        { category: "快门速度", key: "快门速度", value: "电子快门：8 秒至 1/8000 秒" },
                        { category: "照片拍摄模式及参数", key: "单张拍摄", value: "4800万像素" },
                        {
                            category: "照片拍摄模式及参数",
                            key: "定时拍摄",
                            value: "4800万像素 0.7/1/2/3/5/7/10/15/20/30/60秒",
                        },
                        { category: "照片拍摄模式及参数", key: "低光智能拍照", value: "4800万像素 全景拼接（待开发）" },
                        {
                            category: "录像编码及分辨率",
                            key: "录像编码及分辨率",
                            value: "H.264/H.265 4K：3840 × 2160@30fps FHD：1920 × 1080@30fps",
                        },
                        { category: "视频码率", key: "视频码率", value: "4K：85Mbps FHD：30Mbps" },
                        { category: "支持文件系统", key: "支持文件系统", value: "exFAT" },
                        { category: "图片格式", key: "图片格式", value: "JPEG" },
                        { category: "视频格式", key: "视频格式", value: "MP4 (MPEG-4 AVC/H.264/H.265)" },
                        { category: "广角长焦混合光学变倍", key: "广角长焦混合光学变倍", value: "11倍" },
                        { category: "广角长焦混合电子变倍", key: "广角长焦混合电子变倍", value: "100倍" },
                    ],
                    tableData_EN: [
                        { category: "Image Sensor", key: "Image Sensor", value: '1/2" CMOS, Effective Pixels 48MP' },
                        { category: "Lens", key: "Field of View", value: "79°" },
                        { category: "Lens", key: "Equivalent Focal Length", value: "Equivalent Focal Length 25mm" },
                        { category: "Lens", key: "Aperture", value: "F/1.8" },
                        { category: "Lens", key: "Focus Point", value: "5m to Infinity" },
                        { category: "ISO Range", key: "ISO Range", value: "100 to 25600" },
                        { category: "Shutter Speed", key: "Shutter Speed", value: "Electronic Shutter: 8s to 1/8000s" },
                        { category: "Photo Shooting Modes and Parameters", key: "Single Shot", value: "48MP" },
                        {
                            category: "Photo Shooting Modes and Parameters",
                            key: "Timed Shooting",
                            value: "48MP 0.7/1/2/3/5/7/10/15/20/30/60 seconds",
                        },
                        {
                            category: "Photo Shooting Modes and Parameters",
                            key: "Low Light Intelligent Photography",
                            value: "48MP Panorama Stitching (under development)",
                        },
                        {
                            category: "Video Encoding and Resolution",
                            key: "Video Encoding and Resolution",
                            value: "H.264/H.265 4K: 3840 × 2160@30fps FHD: 1920 × 1080@30fps",
                        },
                        { category: "Video Bitrate", key: "Video Bitrate", value: "4K: 85Mbps FHD: 30Mbps" },
                        { category: "Supported File System", key: "Supported File System", value: "exFAT" },
                        { category: "Image Format", key: "Image Format", value: "JPEG" },
                        { category: "Video Format", key: "Video Format", value: "MP4 (MPEG-4 AVC/H.264/H.265)" },
                        {
                            category: "Wide-Angle and Telephoto Hybrid Optical Zoom",
                            key: "Wide-Angle and Telephoto Hybrid Optical Zoom",
                            value: "11x",
                        },
                        {
                            category: "Wide-Angle and Telephoto Hybrid Digital Zoom",
                            key: "Wide-Angle and Telephoto Hybrid Digital Zoom",
                            value: "100x",
                        },
                    ],
                },
                {
                    name_CN: "长焦相机",
                    name_EN: "Telephoto Lens",
                    headers_CN: [
                        { label: "类别", prop: "category" },
                        { label: "参数", prop: "key" },
                        { label: "说明", prop: "value" },
                    ],
                    headers_EN: [
                        { label: "Specifications", prop: "category" },
                        { label: "Parameters", prop: "key" },
                        { label: "Description", prop: "value" },
                    ],
                    tableData_CN: [
                        { category: "影像传感器", key: "影像传感器", value: '1/2" CMOS，有效像素1200万' },
                        { category: "镜头", key: "视场角", value: "28°到109°" },
                        { category: "镜头", key: "等效焦距", value: "81-270mm" },
                        { category: "镜头", key: "焦距", value: "15-50mm" },
                        { category: "镜头", key: "光圈", value: "f/3.7~f/4.5" },
                        { category: "镜头", key: "对焦点", value: "3米至无穷远" },
                        { category: "ISO范围", key: "ISO范围", value: "100 至 25600" },
                        { category: "快门速度", key: "快门速度", value: "电子快门：8 秒至 1/8000 秒" },
                        { category: "照片尺寸", key: "照片尺寸", value: "4000 × 3000" },
                        { category: "照片拍摄模式及参数", key: "单张拍摄", value: "1200万像素" },
                        {
                            category: "照片拍摄模式及参数",
                            key: "定时拍摄",
                            value: "1200万像素 0.7/1/2/3/5/7/10/15/20/30/60 秒",
                        },
                        { category: "照片拍摄模式及参数", key: "低光智能拍照", value: "1200万像素" },
                        {
                            category: "录像编码及分辨率",
                            key: "录像编码及分辨率",
                            value: "H.264/H.265 4K：3840 × 2160@30fps FHD：1920 × 1080@30fps",
                        },
                        { category: "视频码率", key: "视频码率", value: "4K：85Mbps FHD：30Mbps" },
                        { category: "数字变焦", key: "数字变焦", value: "8 倍" },
                        { category: "支持文件系统", key: "支持文件系统", value: "exFAT" },
                        { category: "图片格式", key: "图片格式", value: "JPEG" },
                        { category: "视频格式", key: "视频格式", value: "MP4 (MPEG-4 AVC/H.264)" },
                        { category: "广角长焦混合光学变倍", key: "广角长焦混合光学变倍", value: "11倍" },
                        { category: "广角长焦混合电子变倍", key: "广角长焦混合电子变倍", value: "100倍" },
                    ],
                    tableData_EN: [
                        { category: "Image Sensor", key: "Image Sensor", value: '1/2" CMOS, Effective Pixels 12MP' },
                        { category: "Lens", key: "Field of View", value: "28° to 109°" },
                        { category: "Lens", key: "Equivalent Focal Length", value: "81-270mm" },
                        { category: "Lens", key: "Focal Length", value: "15-50mm" },
                        { category: "Lens", key: "Aperture", value: "f/3.7~f/4.5" },
                        { category: "Lens", key: "Focus Point", value: "3m to Infinity" },
                        { category: "ISO Range", key: "ISO Range", value: "100 to 25600" },
                        { category: "Shutter Speed", key: "Shutter Speed", value: "Electronic Shutter: 8s to 1/8000s" },
                        { category: "Image Size", key: "Image Size", value: "4000 × 3000" },
                        { category: "Photo Shooting Modes and Parameters", key: "Single Shot", value: "12MP" },
                        {
                            category: "Photo Shooting Modes and Parameters",
                            key: "Timed Shooting",
                            value: "12MP 0.7/1/2/3/5/7/10/15/20/30/60 seconds",
                        },
                        {
                            category: "Photo Shooting Modes and Parameters",
                            key: "Low Light Intelligent Photography",
                            value: "12MP",
                        },
                        {
                            category: "Video Encoding and Resolution",
                            key: "Video Encoding and Resolution",
                            value: "H.264/H.265 4K: 3840 × 2160@30fps FHD: 1920 × 1080@30fps",
                        },
                        { category: "Video Bitrate", key: "Video Bitrate", value: "4K: 85Mbps FHD: 30Mbps" },
                        { category: "Digital Zoom", key: "Digital Zoom", value: "8x" },
                        { category: "Supported File System", key: "Supported File System", value: "exFAT" },
                        { category: "Image Format", key: "Image Format", value: "JPEG" },
                        { category: "Video Format", key: "Video Format", value: "MP4 (MPEG-4 AVC/H.264)" },
                        {
                            category: "Wide-Angle and Telephoto Hybrid Optical Zoom",
                            key: "Wide-Angle and Telephoto Hybrid Optical Zoom",
                            value: "11x",
                        },
                        {
                            category: "Wide-Angle and Telephoto Hybrid Digital Zoom",
                            key: "Wide-Angle and Telephoto Hybrid Digital Zoom",
                            value: "100x",
                        },
                    ],
                },
                {
                    name_CN: "红外相机",
                    name_EN: "Lens-Infrared thermal camera",
                    headers_CN: [
                        { label: "类别", prop: "category" },
                        { label: "参数", prop: "key" },
                        { label: "说明", prop: "value" },
                    ],
                    headers_EN: [
                        { label: "Specifications", prop: "category" },
                        { label: "Parameters", prop: "key" },
                        { label: "Description", prop: "value" },
                    ],
                    tableData_CN: [
                        { category: "热成像传感器", key: "热成像传感器", value: "非制冷氧化钒（VOx）" },
                        { category: "像元间距", key: "像元间距", value: "12 µm" },
                        { category: "频率", key: "频率", value: "30Hz" },
                        { category: "镜头", key: "视场角", value: "61°" },
                        { category: "镜头", key: "等效焦距", value: "40mm" },
                        { category: "镜头", key: "光圈", value: "f/1.0" },
                        { category: "镜头", key: "对焦点", value: "5 米至无穷远" },
                        { category: "灵敏度", key: "灵敏度", value: "≤50 mk@F1.1" },
                        { category: "测温方式", key: "测温方式", value: "点测温，区域测温" },
                        {
                            category: "测温范围",
                            key: "测温范围",
                            value: "-20°C 至 150°C（高增益模式），0°C 至 500°C（低增益模式）",
                        },
                        { category: "调色盘", key: "调色盘", value: "白热/黑热/熔岩/铁红/热铁/医疗/彩虹/彩虹1/彩虹2" },
                        {
                            category: "照片尺寸",
                            key: "照片尺寸",
                            value: "普通模式：640 × 512@30fps，超分辨率：1280 × 1024@30fps（开启红外超分功能后，飞行器可根据环境亮度自动开启或关闭超分模式）",
                        },
                        {
                            category: "照片拍摄模式及参数",
                            key: "单张拍摄",
                            value: "普通模式640 × 512，超分模式1280 × 1024",
                        },
                        {
                            category: "照片拍摄模式及参数",
                            key: "定时拍摄",
                            value: "普通模式640 × 512，超分模式1280 × 1024，0.7/1/2/3/5/7/10/15/20/30/60秒",
                        },
                        {
                            category: "录像编码及分辨率",
                            key: "录像编码及分辨率",
                            value: "普通模式：640 × 512@30fps，超分模式：1280 × 1024@30fps",
                        },
                        { category: "视频码率", key: "视频码率", value: "6Mbps" },
                        { category: "数字变焦", key: "数字变焦", value: "28倍" },
                        { category: "支持文件系统", key: "支持文件系统", value: "exFAT" },
                        { category: "图片格式", key: "图片格式", value: "JPEG（8位），R-JPEG（16位）" },
                        { category: "视频格式", key: "视频格式", value: "MP4（MPEG-4 AVC/H.264）" },
                        { category: "红外测温精度", key: "红外测温精度", value: "±2°C 或 ±2%，取较大值" },
                    ],
                    tableData_EN: [
                        { category: "Thermal Imaging Sensor", key: "Thermal Imaging Sensor", value: "Uncooled VOx" },
                        { category: "Pixel Pitch", key: "Pixel Pitch", value: "12 µm" },
                        { category: "Frequency", key: "Frequency", value: "30Hz" },
                        { category: "Lens", key: "Field of View", value: "61°" },
                        { category: "Lens", key: "Equivalent Focal Length", value: "40mm" },
                        { category: "Lens", key: "Aperture", value: "f/1.0" },
                        { category: "Lens", key: "Focus Point", value: "5m to Infinity" },
                        { category: "Sensitivity", key: "Sensitivity", value: "≤50 mk@F1.1" },
                        {
                            category: "Temperature Measurement Method",
                            key: "Temperature Measurement Method",
                            value: "Spot Measurement, Area Measurement",
                        },
                        {
                            category: "Temperature Range",
                            key: "Temperature Range",
                            value: "-20°C to 150°C (High Gain Mode), 0°C to 500°C (Low Gain Mode)",
                        },
                        {
                            category: "Color Palette",
                            key: "Color Palette",
                            value: "White Hot/Black Hot/Lava/Iron Red/Hot Iron/Medical/Rainbow/Rainbow 1/Rainbow 2",
                        },
                        {
                            category: "Image Size",
                            key: "Image Size",
                            value: "Normal Mode: 640 × 512@30fps, Super Resolution: 1280 × 1024@30fps (with infrared super-resolution enabled, the drone can automatically switch super-resolution mode based on ambient brightness)",
                        },
                        {
                            category: "Photo Shooting Modes and Parameters",
                            key: "Single Shot",
                            value: "Normal Mode 640 × 512, Super Resolution 1280 × 1024",
                        },
                        {
                            category: "Photo Shooting Modes and Parameters",
                            key: "Timed Shooting",
                            value: "Normal Mode 640 × 512, Super Resolution 1280 × 1024, 0.7/1/2/3/5/7/10/15/20/30/60 seconds",
                        },
                        {
                            category: "Video Encoding and Resolution",
                            key: "Video Encoding and Resolution",
                            value: "Normal Mode: 640 × 512@30fps, Super Resolution: 1280 × 1024@30fps",
                        },
                        { category: "Video Bitrate", key: "Video Bitrate", value: "6Mbps" },
                        { category: "Digital Zoom", key: "Digital Zoom", value: "28x" },
                        { category: "Supported File System", key: "Supported File System", value: "exFAT" },
                        { category: "Image Format", key: "Image Format", value: "JPEG (8-bit), R-JPEG (16-bit)" },
                        { category: "Video Format", key: "Video Format", value: "MP4 (MPEG-4 AVC/H.264)" },
                        {
                            category: "Infrared Temperature Measurement Accuracy",
                            key: "Infrared Temperature Measurement Accuracy",
                            value: "±2°C or ±2%, whichever is greater",
                        },
                    ],
                },
                {
                    name_CN: "激光测距",
                    name_EN: "Laser-rangefinder",
                    headers_CN: [
                        { label: "参数", prop: "key" },
                        { label: "说明", prop: "value" },
                    ],
                    headers_EN: [
                        { label: "Parameters", prop: "key" },
                        { label: "Description", prop: "value" },
                    ],
                    tableData_CN: [
                        { key: "波长", value: "905nm" },
                        { key: "最大激光功率", value: "≤2w" },
                        { key: "测量精度", value: "±1m" },
                        { key: "测量范围", value: "3-1200m" },
                        { key: "安规等级", value: "Class 1M 类" },
                        { key: "参考发射口径", value: "Φ10×7.5mm" },
                    ],
                    tableData_EN: [
                        { key: "Wavelength", value: "905nm" },
                        { key: "Maximum Laser Power", value: "≤2w" },
                        { key: "Measurement Accuracy", value: "±1m" },
                        { key: "Measurement Range", value: "3-1200m" },
                        { key: "Safety Level", value: "Class 1M" },
                        { key: "Reference Emission Aperture", value: "Φ10×7.5mm" },
                    ],
                },
            ],
            GEMINI40T:[
                {
                    name_CN: "GEMINI40T",
                    name_EN: "GEMINI40T",
                    imageList_CN: [
                        "images/GEMINI40T/parameter/GEMINI40T-CN/GEMINI40T-CN_1.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-CN/GEMINI40T-CN_2.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-CN/GEMINI40T-CN_3.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-CN/GEMINI40T-CN_4.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-CN/GEMINI40T-CN_5.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-CN/GEMINI40T-CN_6.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-CN/GEMINI40T-CN_7.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-CN/GEMINI40T-CN_8.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-CN/GEMINI40T-CN_9.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-CN/GEMINI40T-CN_10.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-CN/GEMINI40T-CN_11.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-CN/GEMINI40T-CN_12.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-CN/GEMINI40T-CN_13.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-CN/GEMINI40T-CN_14.jpg",

                    ],
                    imageList_EN: [
                        "images/GEMINI40T/parameter/GEMINI40T-EN/GEMINI40T-EN_1.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-EN/GEMINI40T-EN_2.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-EN/GEMINI40T-EN_3.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-EN/GEMINI40T-EN_4.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-EN/GEMINI40T-EN_5.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-EN/GEMINI40T-EN_6.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-EN/GEMINI40T-EN_7.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-EN/GEMINI40T-EN_8.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-EN/GEMINI40T-EN_9.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-EN/GEMINI40T-EN_10.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-EN/GEMINI40T-EN_11.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-EN/GEMINI40T-EN_12.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-EN/GEMINI40T-EN_13.jpg",
                        "images/GEMINI40T/parameter/GEMINI40T-EN/GEMINI40T-EN_14.jpg",
                    ] 

                }
            ]
        };
        console.error(11);
        this.allProductsMap["SCORPIO3"] = cloneDeep(this.allProductsMap["SCORPIO4"]);
        this.allProductsMap["LIBRA3"] = cloneDeep(this.allProductsMap["LIBRA4"]);
        this.allProductsMap["LIBRA2"] = cloneDeep(this.allProductsMap["LIBRA4"]);
    },
    async beforeMount() {},
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        spanMethod(tableData) {
            return ({ row, column, rowIndex, columnIndex }) => {
                const data = tableData;
                // 合并 category 列
                if (row.hasOwnProperty("category")) {
                    if (columnIndex === 0) {
                        const category = row.category;
                        let rowspan = 1;
                        for (let i = rowIndex + 1; i < data.length; i++) {
                            if (data[i].category === category) {
                                rowspan++;
                            } else {
                                break;
                            }
                        }
                        if (rowIndex > 0 && data[rowIndex - 1].category === category) {
                            return { rowspan: 0, colspan: 0 };
                        }
                        if (row.colspan) {
                            return { rowspan: 1, colspan: row.colspan };
                        } else {
                            return { rowspan, colspan: 1 };
                        }
                    } else if (columnIndex === 1) {
                        if (row.colspan) {
                            return { rowspan: 0, colspan: 0 };
                        }
                    }
                }

                return { rowspan: 1, colspan: 1 };
            };
        },
        formateTableDataSpan(tableData) {
            let arr = [];
            tableData &&
                tableData.forEach((item, index) => {
                    if (item.category === item.key) {
                        item.colspan = 2;
                    }
                    arr.push(item);
                });
            return arr;
        },
        handleResize() {
            this.$forceUpdate(); // Force update to recalculate drawer size
        }
    },
};
</script>
<style lang="scss" scoped>
.technicalParameter_drawer {
    ::v-deep .el-drawer__header {
        padding: 16px 20px;
        margin-bottom: 0;
        border-bottom: 1px solid #eaeaea;
        color: #333;
        font-weight: 600;
        font-size: 18px;
    }
    
    ::v-deep .el-drawer__body {
        padding: 0;
        overflow-y: auto;
    }
}

.technicalParameter_content {
    padding: 20px;
    height: 100%;
    overflow-y: auto;
    background-color: #f9f9f9;
    
    .product_title {
        font-size: 26px;
        font-weight: 600;
        color: #333;
        margin: 0 0 20px;
        padding-bottom: 15px;
        border-bottom: 2px solid #e0e0e0;
    }
    
    .parameter-section {
        margin-bottom: 30px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
        overflow: hidden;
    }
    
    .technicalParameter_title {
        font-size: 20px;
        line-height: 1.4;
        padding: 15px 20px;
        font-weight: 600;
        background-color: #f2f6fc;
        color: #333;
        margin: 0;
        border-bottom: 1px solid #eaeaea;
    }
    
    .parameter-table {
        margin: 0;
        
        ::v-deep .el-table__header-wrapper {
            th {
                background-color: #f8f9fb;
                color: #333;
                font-weight: 600;
                padding: 12px 8px;
                font-size: 15px;
            }
        }
        
        ::v-deep .el-table__body {
            td {
                padding: 14px 8px;
                line-height: 1.6;
                color: #333;
                font-size: 14px;
                
                &:first-child {
                    font-weight: 500;
                    background-color: #fafbfc;
                }
            }
            
            tr:hover > td {
                background-color: #f5f7fa;
            }
        }
    }
    
    .technicalParameter_item {
        .image-container {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            
            .image-item {
                width: 100%;
                margin-bottom: 20px;
                border-radius: 8px;
                overflow: hidden;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                background-color: #fff;
                
                img {
                    width: 100%;
                    height: auto;
                    object-fit: contain;
                    transition: transform 0.3s ease;
                    
                    &:hover {
                        transform: scale(1.02);
                    }
                }
            }
        }
    }
}

@media (max-width: 768px) {
    .technicalParameter_content {
        padding: 15px;
        
        .product_title {
            font-size: 22px;
            margin-bottom: 15px;
        }
        
        .technicalParameter_title {
            font-size: 18px;
            padding: 12px 15px;
        }
        
        .parameter-table {
            ::v-deep .el-table__header-wrapper {
                th {
                    padding: 10px 5px;
                    font-size: 14px;
                }
            }
            
            ::v-deep .el-table__body {
                td {
                    padding: 10px 5px;
                    font-size: 13px;
                }
            }
        }
    }
}
</style>
